<div
  class="relative w-full min-h-[70vh] flex items-center justify-center overflow-hidden py-20 bg-[#030204]"
>
  <div class="absolute inset-0 z-0 pointer-events-none">
    <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[650px] h-[350px] bg-[#9B0F3B]/25 rounded-full blur-[150px]"></div>
    <div class="absolute top-1/4 right-1/4 w-[400px] h-[400px] bg-[#C71650]/15 rounded-full blur-[140px]"></div>
    <img
      src="auth-bg.webp"
      class="w-full h-full object-cover opacity-20 filter blur-[2px]"
      alt="Casino Background"
    />
    <div class="absolute inset-0 bg-gradient-to-b from-[#030204] via-[#030204]/85 to-[#030204]"></div>
  </div>

  <div
    class="relative z-10 flex flex-col items-center text-center px-6 sm:px-10 md:px-16 w-full max-w-[95%] sm:max-w-[720px] md:max-w-[920px] py-14 md:py-20 rounded-3xl backdrop-blur-2xl bg-gradient-to-b from-[#120810]/95 to-[#030204]/98 border border-[#E7CA96]/30 shadow-[0_25px_60px_rgba(0,0,0,0.85)] group hover:border-[#E7CA96]/50 transition-all duration-300"
  >
    <div class="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#240816]/90 text-[#F6E9D5] text-xs font-bold tracking-wider uppercase mb-6 border border-[#E7CA96]/30 shadow-[0_0_20px_rgba(199, 22, 80,0.4)]">
      <i class="fas fa-crown text-[#E7CA96]"></i>
      <span>Elevate Your Gameplay</span>
    </div>

    <h2
      class="font-black text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.1] tracking-tight mb-5"
    >
      Weaving Narratives, Forging Connections,
      <span class="block bg-clip-text text-transparent bg-gradient-to-r from-[#F6E9D5] via-[#E7CA96] to-[#C72A69] mt-1">
        Creating Unmatched Fun.
      </span>
    </h2>

    <p
      class="text-[#C2ABA3] mt-2 text-sm sm:text-base md:text-lg max-w-2xl leading-relaxed font-normal mb-8"
    >
      Experience the thrill of next-level gaming. Join thousands of winners worldwide on our premier entertainment hub where every spin brings instant opportunity.
    </p>

    <div class="flex flex-wrap items-center justify-center gap-4">
      <button
        (click)="redirectToSignUp()"
        class="cyber-shimmer-btn px-10 py-4 rounded-xl font-black text-sm sm:text-base text-white bg-gradient-to-r from-[#680825] via-[#9B0F3B] to-[#C71650] hover:brightness-115 shadow-[0_8px_30px_rgba(199, 22, 80,0.45)] active:scale-95 transition-all duration-200 flex items-center gap-3 cursor-pointer group"
      >
        <span>Join Now &amp; Play Free</span>
        <i class="fas fa-arrow-right text-xs transition-transform group-hover:translate-x-1"></i>
      </button>
    </div>
  </div>
</div>
